const config = {   EMPRESA: "zapresponder" };  export default config;
